import ApiServiceData from "../api.service";
import S3ActionType from "services/domain/administration/S3Action";

export const CloudStorageRelativeUrl = "/v1/api/gcs";

export default class BucketS3Service extends ApiServiceData {
	public getS3UrlForAction(
		fileName: string,
		s3Action: S3ActionType.DOWNLOAD | S3ActionType.UPLOAD | S3ActionType.DELETE
	): Promise<string> {
		return this.get(`${CloudStorageRelativeUrl}/${encodeURIComponent(fileName)}/${s3Action}`)
			.then(res => {
				return res.data as string;
			})
			.catch(error => {
				throw error.response;
			});
	}

	public getS3UrlPublicFiles(
		fileName: string,
		s3Action: S3ActionType.DOWNLOAD | S3ActionType.UPLOAD | S3ActionType.DELETE
	): Promise<string> {
		return this.publicGet(`${CloudStorageRelativeUrl}/public-files/${encodeURIComponent(fileName)}/${s3Action}`)
			.then(res => {
				return res.data as string;
			})
			.catch(error => {
				throw error.response;
			});
	}

	public getS3UrlForPublicAction(id: string): Promise<string> {
		return this.publicGet(`${CloudStorageRelativeUrl}/${id}`)
			.then(res => {
				return res.data as string;
			})
			.catch(error => {
				throw error.response;
			});
	}
}
